import { render, staticRenderFns } from "./CreateView.vue?vue&type=template&id=67e1db34&scoped=true"
import script from "./CreateView.vue?vue&type=script&lang=js"
export * from "./CreateView.vue?vue&type=script&lang=js"
import style0 from "./CreateView.vue?vue&type=style&index=0&id=67e1db34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e1db34",
  null
  
)

export default component.exports